<template>
  <div class="question">
    <div class="body" v-html="selected_question.question_content"></div>
    <div
      class="answer"
      :class="[
        selected_question.is_correct_answer ? 'correct' : 'incorrect',
      ]">
        {{ selected_question.answer_content }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BcgResponseTabTestQuestion',

  props: {
    selected_question: {
      type: Object,
      default: null
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/styles/variables.scss';

.question {
  margin: 10px 0;

  .body {
    font-size: 16px;
    margin: 10px 0;
    font-weight: 500;
    color: #555555;
  }

  .answer {
    margin: 5px 0;

    &.correct {
      color: $green;
    }
    &.incorrect {
      color: $red-color;
    }
  }
}
</style>
